/**
 * @ngdoc controller
 * @name userMaintenanceModule.EditIntermediaryController
 * @description This controller is used for user maintenance module. This mainly
 *              deals with edit issuer user details.
 * @requires userService is the service which is being used to interact with
 *           REST
 * @requires $scope,$stateParams for storing/passing information in scope/state
 * @requires $log mainly used for logging. Used only $log.debug and could be
 *           enabled/disabled based on need.
 * @requires $state for state routing
 */

angular
  .module('userMaintenanceDwtModule')
  .controller('EditIntermediaryDwtController', [
    '$scope',
    '$log',
    '$state',
    '$stateParams',
    '$sessionStorage',
    '$timeout',
    'userService',
    'DwtIntermediaryUser',
    function (
      $scope,
      $log,
      $state,
      $stateParams,
      $sessionStorage,
      $timeout,
      userService,
      DwtIntermediaryUser
    ) {
      $scope.emailPattern = appConstant.EMAIL_REGEX_PATTERN;

      $scope.userId = $stateParams.userId;
      $scope.loggedInId = $sessionStorage.userId;
      $scope.groupId = $stateParams.groupId;
      $scope.prodType = $sessionStorage.productType;
      // Below is the service call to interact with REST and get the
      // user details
      userService
        .getViewUser($scope.userId, 'IN', $scope.groupId, $scope.prodType)
        .query()
        .$promise.then(
          function (data) {
            $scope.editUserDetails = new DwtIntermediaryUser(
              data,
              $scope.groupId,
              $scope.userId,
              $scope.loggedInId,
              null,
              $scope.prodType
            );
          },
          function (error) {
            $log.debug(error);
          }
        );

      $scope.callOnChange = function (accType) {
        if ('D' === accType) {
          $scope.editUserDetails.title = null;
          $scope.editUserDetails.firstName = null;
        }
      };

      $scope.successCallback = function (response) {
        if (200 === response.httpStatusCode) {
          $scope.editUserSuccess = true;
          $scope.editUserErrorMsg = null;
          $scope.editUserSuccessMsg = response.message;
          $('#successMsg').modal('show');
          $timeout(function () {
            $('#successMsg').modal('hide');
            $('.modal-backdrop').remove();
            $state.go('userMaintenanceForDWT.intermediaryUserListDwt', {
              groupId: $scope.groupId,
            });
          }, 2000);
        } else {
          $scope.editUserError = true;
          $scope.editUserSuccessMsg = null;
          $scope.editUserErrorMsg = response.message;
        }
      };
      $scope.errorCallback = function (error) {
        $scope.editUserError = true;
        $scope.editUserSuccessMsg = null;
        $scope.editUserErrorMsg = error.data.errors[0].errorMessage;
      };
    },
  ]);
